export default __webpack_public_path__ + "static/media/product_1.c7d60571.jpg";